import { render, staticRenderFns } from "./ApprovalPendingPanel.vue?vue&type=template&id=7ffa7675&scoped=true"
import script from "./ApprovalPendingPanel.vue?vue&type=script&lang=js"
export * from "./ApprovalPendingPanel.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPendingPanel.vue?vue&type=style&index=0&id=7ffa7675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa7675",
  null
  
)

export default component.exports